import "./RouterLinkComp.css";
import { defineComponent as m, computed as t, resolveComponent as s, openBlock as u, createBlock as i, normalizeClass as p, withCtx as c, renderSlot as _ } from "vue";
import { _ as d } from "./_plugin-vue_export-helper.dad06003.js";
const k = /* @__PURE__ */ m({
  __name: "RouterLinkComp",
  props: {
    small: Boolean,
    medium: Boolean,
    large: Boolean,
    navGray: Boolean,
    to: {
      type: [Object, String],
      required: !0
    }
  },
  setup(o) {
    const e = o, r = t(() => !e.small && !e.medium && !e.large), n = t(() => ({
      routerLinkComp: !0,
      "routerLinkComp--small": e.small,
      "routerLinkComp--medium": e.medium || r.value,
      "routerLinkComp--large": e.large,
      "routerLinkComp--navGray": e.navGray
    }));
    return (a, C) => {
      const l = s("router-link");
      return u(), i(l, {
        class: p(n.value),
        to: o.to
      }, {
        default: c(() => [
          _(a.$slots, "default", {}, void 0, !0)
        ]),
        _: 3
      }, 8, ["class", "to"]);
    };
  }
});
const g = /* @__PURE__ */ d(k, [["__scopeId", "data-v-948d28f8"]]);
export {
  g as RouterLinkComp
};
//# sourceMappingURL=RouterLinkComp.js.map
